<template>
  <div class="task taskButton taskDownload">
    <button v-on:click="callTask()" v-tooltip="{content: task.info, delay: { show: 400, hide: 100 }, placement: 'bottom'}" type="button" class="w3-buttonTask">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="taskLoading" class="spinner-loading" :line-size='2' :size="18" line-fg-color='#5dbecd' />
        <i v-else :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
      </transition>
      <span>{{ task.label }}</span>
    </button>
    <div class="message">
      <transition name="fade" mode="out-in">
        <span v-if="!taskLoading && taskError" class="label error_validate"> {{ getLang('taskError') }} </span>
        <span v-else-if="!taskLoading && taskResp && taskResp !== ''" class="label ok_validate"> {{ taskResp }} </span>
      </transition>
    </div>
  </div>
</template>

<script>
import * as api from '../../utils/api'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../../language'

export default {
  name: 'definition-task-download',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'repeatableItemIndex',
    'calledTaskIndex'
  ],
  data () {
    return {
      taskError: false,
      taskResp: '',
      taskLoading: false
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    callTask () {
      this.taskLoading = true

      var dataParam = { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }
      if (this.languageSelected) {
        dataParam.lang = this.languageSelected.key
      } else {
        dataParam.lang = null
      }

      api.call({
        domainEndpoint: this.type.domainEndpoint,
        url: this.task.type.endpoint,
        token: this.type.token,
        version: this.type.version,
        method: 'POST',
        lang: this.getLang(),
        authorization: this.authorization,
        blobMode: true,
        data: dataParam
      })
        .then(resp => {
          var fileName = this.task.id
          var contentDisposition = resp.request.getResponseHeader('Content-Disposition')
          var fileNameMatch = contentDisposition.match(/filename=(.+)/)
          if (fileNameMatch && fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
          var fileDownload = require('js-file-download')
          fileDownload(resp.data, fileName)
          this.taskError = false
          this.taskLoading = false
        })
        .catch(err => {
          console.log(err)
          this.taskError = true
          this.taskLoading = false
        })
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  watch: {
    calledTaskIndex: {
      handler: function (val) {
        this.callTask()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskDownload.vue